import { FC, useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { observer } from 'mobx-react'
import { getIllustration } from '@/components/Illustration/helpers'
import './Illustration.css'

interface IconProps {
  type?: string
}

export const Illustration: FC<IconProps> = observer(({ type }): React.JSX.Element => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { themeId } = store.InterfaceState

  if (!type) return <></>

  const { component: Icon, fillColor } = getIllustration(type, themeId)

  if (!Icon) return <></>

  return (
    <div className="illustration">
      <Icon fillColor={fillColor ?? 'var(--icon-main-color)'} isMobile={isMobile} />
    </div>
  )
})
